function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, " .st0{fill:#FFFFFF;}");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M11.9,54.5h34c19.2,0,28.2,7.2,28.2,20.2c0,0.8,0,2.2-0.2,4.1c-1.2,9.7-5.9,14.7-14.2,17.5   c6.2,2.6,10.8,8.1,10.8,17.2c0,0.2,0,1.1-0.1,2.5c-1.4,16.5-10.9,23.5-33.1,23.5H0L11.9,54.5L11.9,54.5z M36,121   c7.4,0,10.1-1.5,11.2-7.9c0.1-0.7,0.2-1.9,0.2-2.6c0-4.8-3.1-6.1-8.8-6.1h-9.9L26.4,121H36L36,121z M38,88.6   c9.3,0,11.5-1.9,12.2-7.4c0.1-0.8,0.1-1.8,0.1-2.2c0-4.1-2-5.9-8-5.9h-9.2l-2.2,15.5H38z"
}), React.createElement("path", {
  className: "st0",
  d: "M133.9,123.1c-2.8,15.3-7.7,17.9-28,17.9c-22.6,0-28.9-8.5-28.9-23.2c0-3.2,0.4-6.7,0.8-10.6   C80.8,84.6,85,73.4,111,73.4c21.4,0,27.8,8.5,27.8,22.9c0,3.8-0.4,7.9-1.9,16.9c-0.2,1.4-0.6,2-3.1,2H98.5c-0.1,0.7-0.1,1.4-0.1,2   c0,4.5,2.6,5.8,9.5,5.8L133.9,123.1L133.9,123.1z M117,102.7c0.5-2.4,0.7-4.4,0.7-5.9c0-4.8-2.4-5.9-7.8-5.9   c-6.1,0-8.2,0.7-9.8,11.8H117L117,102.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M152.8,60.7h22.1l-2.1,14.1H191l-2.4,16.5h-18.2l-2.4,17.1c-0.5,3.3-0.8,6.7-0.8,8.8c0,4.8,1.7,5.9,7.2,5.9   h10.8c-1.7,15.2-5.4,17.9-20,17.9c-16.6,0-20.8-5.3-20.8-16.4c0-3.4,0.8-10.5,1.8-17.3L152.8,60.7L152.8,60.7z"
})), React.createElement("path", {
  className: "st0",
  d: "M308.2,0c-54.8,0-99.3,44.5-99.3,99.3s44.5,99.3,99.3,99.3s99.3-44.5,99.3-99.3S363,0,308.2,0L308.2,0z   M303.3,122c-2,16.5-3.9,17.6-17.5,17.6h-47.1l0.9-6.6c2-15.8,2.2-19.2,29.3-34.6c8.5-4.8,15.2-8.6,15.2-14.6  c0-4.8-3.9-5.6-9.1-5.6h-28.4c1.5-14.4,4.8-18.9,29-18.9c22.1,0,31.7,6.2,31.7,20.9c0,19-12.3,25-28.2,33  c-7.8,3.9-12.9,6.8-15.2,8.9H303.3L303.3,122z M375.4,68c-1.4,10.1-5.7,10.3-17.6,10.3H337l-1.8,12.3h6.2  c20.5,0,29.4,7.9,29.4,22.1c0,19.7-10.1,27-32.4,27h-30c2.2-15.2,4.8-17.6,18.4-17.6h12.8c6,0,10.5-0.9,10.5-7.7  c0-5.1-4.4-6.2-10.9-6.2h-19.6c-3.7,0-4.9-0.3-4.9-2.6c0-0.4,0-1,0.1-1.6l6.1-43.3h55.6L375.4,68L375.4,68z"
}));

var SvgBet25Logo = function SvgBet25Logo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Lag_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.4 198.6",
    style: {
      enableBackground: "new 0 0 407.4 198.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBet25Logo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bet25-logo.95627630.svg";
export { ForwardRef as ReactComponent };